module.exports = __webpack_public_path__ + "b5327880557f02cfb89cec3b9cb26eb2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.html
// module id = 2120
// module chunks = 0